import React from 'react';

const RoleBadge = ({ role }) => {

  return (
    <div className='role-badge' style={{
        display: 'inline-flex',
        padding: '12px',
        alignItems: 'center',
        gap: '38px',
        borderRadius: '5px',
        background: 'rgba(42, 53, 61, 0.20)',
        color: '#2A353D',
        fontSize: '14px',
        lineHeight: '18px',
    }}><p style={{
        height: '18px',
        lineClamp: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }}>{role}</p></div>
  );
};

export default RoleBadge; 